/* eslint-disable react/jsx-max-depth */
import * as React from 'react';
import './contact-us.css';
import FullLogo from './icons/fullLogo';
import { graphql, useStaticQuery } from 'gatsby';

export function ContactUs(): React.ReactElement {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "paper-signing.jpg" }) {
        childImageSharp {
          # Specify a fixed image and fragment.
          # The default width is 400 pixels
          fixed(width: 1500) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);
  return (
    <div
      className="team"
      id="team"
      style={{
        background: `url(${data.file.childImageSharp.fixed.src})`,
        backgroundSize: 'cover',
      }}
    >
      <div className="team-wrapper" />
      <div className="container team-container">
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2>Kontakt</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 text-center">
            <FullLogo className="contact__main__logo" />
            <div className="contact__main__address">ul. Strzelecka 7B, 80-803 Gdańsk</div>
            <div className="contact__main__email">
              <a href="mailto:kancelaria@advocare.pl">kancelaria@advocare.pl</a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2 />
          </div>
        </div>
        <div className="row">
          <div className="offset-md-1 col-sm-12 col-md-7">
            <div className="team-member">
              <div className="team-member-header" role="tab" id="headingOne">
                <h5 className="mb-0">
                  <div className="advcr-team-name">
                    adw. <strong>Anna Sklinda-Maciejewska</strong>
                  </div>
                  <div className="advcr-team-phone">
                    tel.{' '}
                    <a className="advcr-team-phone-link" href="tel:605030570">
                      605 030 470
                    </a>
                  </div>
                  <div className="advcr-team-email">
                    e-mail{' '}
                    <a className="advcr-team-email-link" href="mailto:asklinda@advocare.pl">
                      asklinda@advocare.pl
                    </a>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="offset-md-4 col-md-7">
            <div className="team-member">
              <div className="team-member-header" role="tab" id="headingTwo">
                <h5 className="mb-0">
                  <div className="advcr-team-name">
                    adw. <strong>Alicja Wojciechowska</strong>
                  </div>
                  <div className="advcr-team-phone">
                    tel.{' '}
                    <a className="advcr-team-phone-link" href="tel:508105790">
                      508 105 790
                    </a>
                  </div>
                  <div className="advcr-team-email">
                    e-mail{' '}
                    <a className="advcr-team-email-link" href="mailto:awojciechowska@advocare.pl">
                      awojciechowska@advocare.pl
                    </a>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2 />
          </div>
        </div>
      </div>
    </div>
  );
}
